/**
 * 안전 홈페이지가 다루는 API 응답 모양 — front `lib/types.ts` 에서 이 앱이 읽는 칸만 옮겼다.
 *
 * 서버 DTO 는 하나다. 칸을 더할 때는 front 쪽 정의와 같은 이름·같은 뜻으로 적는다.
 */

export type UserType = 'super_admin' | 'admin' | 'user';

export function isAdministrator(userType: UserType | undefined): boolean {
  return userType === 'super_admin' || userType === 'admin';
}

export type SessionUser = {
  id: string;
  email: string;
  name: string;
  rank: string | null;
  userType: UserType;
  mustChangePassword: boolean;
};

export type MenuPermission = {
  menuKey: string;
  canView: boolean;
  canCreate: boolean;
  canEdit: boolean;
  canDelete: boolean;
};

/** `GET /api/v1/auth/session` 응답 본문. 표시용이지 인가가 아니다 — 판정은 서버가 매 요청 한다. */
export type Session = {
  authenticated: boolean;
  user: SessionUser | null;
  visibleMenuKeys: string[];
  menuPermissions: MenuPermission[];
  /**
   * 비밀번호는 맞았고 한 걸음이 더 남았다(라운지 서버 · DOC-138 새 브라우저 본인확인 · V618 로그인 OTP).
   * 이 답이 오면 아직 로그인이 아니다 — 로그인 화면이 본인확인 창을 띄운다(pages/login/DeviceVerifyModal).
   */
  deviceChallenge?: DeviceChallenge | null;
};

export type DeviceChannelKind = 'PHONE' | 'EMAIL';

export type DeviceChallenge = {
  pendingId: string;
  /** 고를 수 있는 길과 가린 받는 곳. 로그인 OTP 를 켠 사람은 `TOTP` 하나만 온다. */
  channels: { kind: DeviceChannelKind | 'TOTP'; masked: string | null }[];
  /** 갈래를 고르고 번호를 맞히는 데 주는 시간(초). 지나면 다시 로그인한다. */
  expiresInSeconds: number;
};

export type SiteCategory = '국내진행현장' | '국내계약현장' | '해외진행현장' | '해외검토현장';
export type SiteStatus = '진행' | '평가' | '미진행' | '준공';

/** `GET /api/v1/sites` 의 한 줄 중 이 앱이 읽는 칸. */
export type Site = {
  id: string;
  name: string;
  siteCategory: SiteCategory;
  status: SiteStatus;
  sortOrder: number;
};
